var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('Layout',[_c('div',{staticClass:"container mt-6 mb-6 p-2"},[_c('span',{staticClass:"subtitle is-3"},[_vm._v(" Desculpe :( ")]),_c('br'),_c('span',{staticClass:"title is-3"},[_vm._v(" Página Não encontrada ")])])])
}
var staticRenderFns = []

export { render, staticRenderFns }